<template>
  <div class="markdown-body">
    <h3 id="faq">
      <strong>FAQ</strong>
    </h3>
    <p>
      <strong>What is FlashPay?</strong>
    </p>
    <p>FlashPay is the electronic payment services provider in the form of e-money which may allow the Indonesian Users to conduct top-up balance, balance transfer and conduct payment to the merchant through FlashPay Mobile-Page (mobile phone web based) H5 of each Users.</p>
    <p>
      <strong>What is FlashPay used for?</strong>
    </p>
    <p>We currently support top-ups, transfers/payments, and withdrawals. In the future, we will provide other payment scenarios to meet users&#39; consumption needs.</p>
    <p>
      <strong>Am I eligible to use FlashPay?</strong>
    </p>
    <p>The users must be at least 21 years old and have an Identity Card (KTP). Please read FlashPayUsers Terms &amp; Conditions further for a more complete explanation.</p>
    <p>
      <strong>How can I register the FlashPay Account?</strong>
    </p>
    <p>The applicant of FlashPay Account is only intended for individual users, where each individual shall only open 1 (one) account, and by filling the required information and private data as required along the registration process. </p>
    <p>Further registration process and requirement may be read in FlashPay Users Terms and Conditions.</p>
    <p>
      <strong>How can I  register for a FlashPay account?</strong>
    </p>
    <p>Is as follows:</p>
    <ol>
      <li>Prepare your mobile phone. There is no restriction on brand, type, operating system, communication service provider. </li>
      <li>Make sure your phone is connected to internet network. The internet network can be an internet network provided by mobile communication services or WiFi network according to your location.</li>
      <li>Enter your mobile phone number (phone) that is registered in accordance with Indonesian regulations and is active. </li>
      <li>After entering your phone number, please read the Terms &amp; Conditions and Privacy Policy. You cannot do further activities before reading the Terms &amp; Conditions and Privacy Policy and &quot;check&quot; the box that we have provided. </li>
      <li>After reading the Terms &amp; Conditions and Privacy Policy and check as confirmation, then select &quot;Send Code&quot;. </li>
      <li>We will send an OTP message via WhatsApp. Make sure your cell phone has the WhatsApp application and is actively connected to the phone number you are using. We will send OTP every time you login to FlashPay. The OTP that we send is only valid for a period of 5 minutes and is only valid for 1 (one) time use. </li>
      <li>After receiving OTP on your WhatsApp application, then input the OTP number. </li>
      <li>You have successfully logged in to FlashPay </li>
      <li>If you have not activated, then FlashPay cannot be used to make transactions (Top-Up, transfer, and withdrawal).</li>
      <li>You must activate according to the pop-up on your phone screen. </li>
      <li>Choose/click &quot;activation&quot;. </li>
      <li>Prepare your ID card, then photograph your ID card through your phone screen that we have displayed</li>
      <li>After the ID card is successfully photographed and received by us, the information on your screen will appear according to the information on your ID card. </li>
      <li>Check the information on the screen again with the conditions and information according to the actual situation. </li>
      <li>Continue to the next stage, you will be asked to take a selfie using your phone according to the instructions given by FlashPay. Please do not use masks, face coverings, hats, and other objects that interfere with the camera&#39;s capture of your face. Please take a selfie in a place that has sufficient light intensity so that your face can be captured by the camera clearly. FlashPay will directly and automatically capture your face using the front camera of your mobile phone. </li>
      <li>After successfully taking a selfie as a form of verification of your identity, the next step is to enter the password that is used in every transaction that you will do using FlashPay. </li>
      <li>The registered password is numeric, and cannot be the algorithm 111111, 123456, or your date of birth. </li>
      <li>Please remember the password you registered, if in the future you forget the password you have registered, click &quot;forgot password&quot; and follow the next steps to register the password again. </li>
      <li>After the password is successfully registered, then you have successfully registered FlashPay and FlashPay can be used to make transactions.</li>
    </ol>
    <p>
      <strong>Is there any fee to register for FlashPay?</strong>
    </p>
    <p>FlashPay registration is free of charge.</p>
    <p>
      <strong>If I don&#39;t have an Indonesian ID card (KTP), can I register for FlashPay?</strong>
    </p>
    <p>FlashPay can only be used for Indonesia Citizen who already has an Indonesian ID card (KTP).</p>
    <p>
      <strong>Can I have multiple FlashPay accounts?</strong>
    </p>
    <p>The users can only have 1 FlashPay account for each 1 (one) KTP. </p>
    <p>
      <strong>How do I contact FlashPay?</strong>
    </p>
    <p>
      Please contact us at:
      Phone        : +6221-5723257
      E-mail        :
      <a href="mailto:&#99;&#x73;&#45;&#112;&#97;&#x79;&#45;&#105;&#100;&#64;&#x66;&#x6c;&#x61;&#x73;&#x68;&#x66;&#x69;&#110;&#x2e;&#99;&#111;&#x6d;">&#99;&#x73;&#45;&#112;&#97;&#x79;&#45;&#105;&#100;&#64;&#x66;&#x6c;&#x61;&#x73;&#x68;&#x66;&#x69;&#110;&#x2e;&#99;&#111;&#x6d;</a>
    </p>
    <p>
      <strong>Customer Service working hours?</strong>
    </p>
    <p>
      Our Customer Service is active on:
      Weekdays    :Monday - Friday
      Working hours    :09.00 WIB - 21.00 WIB
    </p>
    <p>
      <strong>Can I change my personal information?</strong>
    </p>
    <p>Please contact FlashPay Customer Service for changes to personal information.</p>
    <p>
      <strong>What if I want to change the phone number?</strong>
    </p>
    <p>If You want to change Your phone, you need to contact the Customer Service to verify and complete Your application.</p>
    <p>
      <strong>Is it possible to do transaction using multiple devices for the same account?</strong>
    </p>
    <p>Each account can only do transaction through one device.</p>
    <p>
      <strong>My account is blocked after entering the wrong password, how do I unlock it?</strong>
    </p>
    <p>The system will automatically open after 24 hours</p>
    <p>
      <strong>How to change Your password?</strong>
    </p>
    <ol>
      <li>Click &quot;Me&quot;</li>
      <li>Open &quot; Payment Settings&quot; then select &quot;Payment Password&quot;</li>
      <li>Enter your current password</li>
      <li>Enter your new password</li>
    </ol>
    <p>
      <strong>Are there any transaction fees?</strong>
    </p>
    <p>For now, FlashPay does not charge any fees for the transactions.  Any changes to transaction fees will be notified to users in accordance with applicable regulations.</p>
  </div>
</template>

<script>
export default {
  name: 'FAQ'
}
</script>

<style scoped>
@import "../../styles/markdown.css";
</style>
